import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { fetchDataAsync, setCurrentWatch, selectApp } from "../../app/appSlice";
import Loading from "../Loading/Loading";

const Watch = ({ playerRef }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isPlayerReady, series_id } = useSelector(selectApp).currentWatch;

  useEffect(() => {
    const handleBackKey = (event) => {
      if (event.keyCode === 10009 || event.keyCode === 4) {
        history.goBack();
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleBackKey);
    return () => {
      dispatch(setCurrentWatch({ isPlayerReady: false, isPlaying: false }));
      window.removeEventListener("keydown", handleBackKey);
    };
  }, [dispatch, history]);

  useEffect(() => {
    if (series_id) {
      
      dispatch(fetchDataAsync(`watch.php?series_id=${series_id}`))
        .then(res => dispatch(setCurrentWatch({ data: res })))
        .catch(err => console.error("Watch fetch error", err));
    }
  }, [dispatch, series_id]);

  return <div className="main-container">{!isPlayerReady && <Loading />}</div>;
};

export default Watch;
